import { fixFloat } from '@/helpers'
import { normalizeOrderItemExtraItems } from '@/utils/Extra/Item'

/**
 * Normalize order extras.
 *
 * @param {Object} orderItem - The order item object
 * @param {Array} extras - The extras array
 * @return {Array} The normalized extras
 */
export function normalizeOrderItemExtras({ orderItem, extras = [] }) {
  return extras.reduce((extras, extra) => {
    const { active, items = [] } = extra

    if (active && items.some(({ active }) => active))
      extras.push(normalizeOrderItemExtra({ orderItem, extra }))

    return extras
  }, [])
}

/**
 * Normalize the order item extra by calculating item quantities and total prices.
 *
 * @param {Object} orderItem - The order item object
 * @param {Array} extra - The extra object
 * @return {Object} Normalized order item extra
 */
export function normalizeOrderItemExtra({ orderItem, extra }) {
  return {
    ...extra,
    items: normalizeOrderItemExtraItems({ orderItem, extraItems: extra.items }),
    get quantity() {
      const { selectedItems } = this

      let quantity = selectedItems.reduce(
        (acc, { quantity }) => acc + quantity,
        0,
      )

      quantity = fixFloat(quantity)

      return quantity
    },
    get selectedItems() {
      const { items } = this

      return items.filter(({ quantity }) => quantity !== 0)
    },
    get totalPrice() {
      const { selectedItems } = this

      let totalPrice = selectedItems.reduce(
        (acc, { totalPrice }) => acc + totalPrice,
        0,
      )

      totalPrice = fixFloat(totalPrice)

      return totalPrice
    },
  }
}
